import { render } from "./XMatrix.vue?vue&type=template&id=5bb26814&scoped=true"
import script from "./XMatrix.vue?vue&type=script&lang=js"
export * from "./XMatrix.vue?vue&type=script&lang=js"

import "./XMatrix.vue?vue&type=style&index=0&id=5bb26814&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb26814"]])

export default __exports__